import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import UniversalHeader from '../header/UniversalHeader';
import { useNavigation } from '../../contexts/NavigationContext';
import './UniversalPage.css';

export interface UniversalPageProps {
  isOpen: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  status?: string;
  statusType?: 'active' | 'closed' | 'pending';
  avatar?: {
    icon?: string;
    imageUrl?: string;
    color?: string;
  };
  coverImage?: string; // URL большого фонового изображения (как в Twitter/Facebook)
  onMenu?: () => void;
  showMenu?: boolean;
  showBackButton?: boolean; // Контроль отображения кнопки назад
  menuButtonRef?: React.RefObject<HTMLButtonElement | null>;
  onClose: () => void;
  onClick?: () => void;
  clickable?: boolean;
  centered?: boolean;
  infoRow?: {
    members?: {
      count: number;
      onClick?: () => void;
      getLabel?: (count: number) => string; // Функция для получения названия с правильными окончаниями
    };
    status?: {
      text: string;
      type: 'active' | 'closed' | 'pending';
    };
  };
  children: React.ReactNode;
  className?: string;
}

const UniversalPage: React.FC<UniversalPageProps> = ({
  isOpen,
  title,
  subtitle,
  status,
  statusType = 'active',
  avatar,
  coverImage,
  onClose,
  onClick,
  clickable = false,
  centered = false,
  infoRow,
  children,
  className = '',
  onMenu,
  showMenu = false,
  showBackButton = true,
  menuButtonRef,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const { showBack, hideBack } = useNavigation();
  const onCloseRef = useRef(onClose);

  // Обновляем ref при изменении onClose
  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (isOpen) {
      showBack(() => {
        onCloseRef.current();
      });
    } else {
      hideBack();
    }

    return () => {
      hideBack();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);


  useEffect(() => {
    if (isOpen) {
      // Минимальная задержка для деликатной анимации
      setTimeout(() => setIsVisible(true), 20);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className={`universal-page ${className} ${isVisible ? 'fade-in' : ''}`}>
      <UniversalHeader
        title={title}
        subtitle={subtitle}
        status={status}
        statusType={statusType}
        avatar={avatar}
        coverImage={coverImage}
        onBack={onClose}
        onClick={onClick}
        clickable={clickable}
        centered={centered}
        infoRow={infoRow}
        onMenu={onMenu}
        showMenu={showMenu}
        showBackButton={showBackButton}
      />
      <div className="universal-page-content">
        {children}
      </div>
    </div>,
    document.body
  );
};

export default UniversalPage;

